import Backbone from '@rover/globals/backbone';
import jQuery from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import _ from '@rover/globals/underscore';
import { pollModerationResult } from '@rover/react-lib/src/pages/account/photoModeration/moderationPolling';
import { classifyModerationResult } from '@rover/react-lib/src/pages/account/photoModeration/moderationReasons';
import { apiUrl } from '@rover/utilities/apiUrl';
import emitMetric from '@rover/utilities/emitMetric';

(function ($) {
  Rover.models.Image = Backbone.Model.extend({
    idAttribute: 'url',
    urlRoot: apiUrl('images/'),
    defaults: {
      thumb: null,
      image: null,
      caption: null,
      index: null,
    },
    url() {
      if (this.isNew()) return this.urlRoot;
      return this.get('url');
    },
  });

  Rover.models.LegacyImage = Backbone.Model.extend({
    defaults: {
      id: null,
      thumb: null,
      image: null,
      caption: null,
      index: null,
    },
  });

  Rover.models.ImageCollection = Backbone.Collection.extend({
    model: Rover.models.Image,
    initialize(models, opts) {
      const options = opts || {};
      this.objectType = options.objectType || null;
      this.objectOpk = options.objectOpk || null;

      // Allow specifying the collection URL on instantiation
      if (options.url) {
        this.url = options.url;
      }
      return this;
    },
    parse(resp) {
      return resp.results;
    },
    create(opts) {
      const options = _.extend(
        {
          url: this.url,
          addToCollection: true,
        },
        opts
      );
      const { success } = options;
      const self = this;

      options.success = function (model) {
        if (options.addToCollection) self.add(model);
        if (success) success(model);
      };

      this.uploadS3Image(options);
    },
    validateFileSize(file) {
      if (file.size >= Rover.settings.imageUploadMaxSize) {
        return `File size too large. Got ${file.size}. Maximum is ${Rover.settings.imageUploadMaxSize}.`;
      }
      return null;
    },
    uploadS3Image(uploadOpts) {
      const self = this;
      const opts = _.extend(
        {
          authorizeUrl: Rover.urls.imageUploadAuthorize,
        },
        uploadOpts
      );
      const $input = $('<input>').attr('type', 'file').fileupload(_.extend({}, opts.fileupload));
      const { file } = opts;

      // Handle uploading the file to the signed S3 url
      // and calling a callback on success
      // The original method's opts.error will be called
      // on error
      const uploadToS3 = function (fileToUpload, url, cb) {
        $input.fileupload('send', {
          url,
          files: [fileToUpload],
          type: 'PUT',
          multipart: false,
          beforeSend(xhr) {
            xhr.setRequestHeader('Content-Type', fileToUpload.type);
            xhr.setRequestHeader('Content-Disposition', 'inline');
          },
          success() {
            cb();
          },
          error: opts.error,
        });
      };

      // 1. Get a signed s3 url
      // 2. Upload our file to the signed s3 url
      // 3. POST the url to our collection root url to register it
      // 4. Add the created model to this collection and fire success
      $.ajax({
        method: 'POST',
        url: opts.authorizeUrl,
        data: {
          file_name: file.name,
          content_type: file.type,
          object_type: this.objectType,
          object_opk: this.objectOpk,
        },
        beforeSend: _.bind(function (xhr) {
          const error = this.validateFileSize(file);
          if (!error) return true;
          opts.error(xhr, error, '');
          return false;
        }, this),
        success(authorizeData) {
          const s3Url = authorizeData.upload_url;
          uploadToS3(file, s3Url, () => {
            $.ajax({
              method: 'POST',
              url: self.awaitModeration ? Rover.urls.personImageModeration : self.url,
              data: {
                image_url: s3Url,
              },
              success(modelData) {
                if (self.awaitModeration) {
                  const onModerated = (moderationResult) => {
                    const outcome = classifyModerationResult(moderationResult);
                    if (outcome.status === 'passed') {
                      const Model = self.model;
                      if (opts.success) opts.success(new Model(modelData.content_object));
                      return;
                    }
                    if (outcome.status === 'check_failed' && outcome.cause === 'timed_out') {
                      emitMetric('gallery_photo_moderation_timed_out');
                    }
                    if (opts.error) {
                      opts.error(null, {
                        moderationOutcome: outcome,
                        moderationResultOpk: modelData.opk,
                      });
                    }
                  };

                  pollModerationResult(modelData.opk)
                    .then(onModerated)
                    .catch((error) => {
                      if (opts.error) opts.error(error);
                    });

                  return;
                }

                const Model = self.model;
                const model = new Model(modelData);
                if (opts.success) opts.success(model);
              },
              error: opts.error,
            });
          });
        },
        error: opts.error,
      });
    },
  });

  Rover.collections.PersonImageCollection = Rover.models.ImageCollection.extend({
    url: `${Rover.urls.personImageListAPI}?page_size=2000`,
  });

  Rover.collections.PetImageCollection = Rover.models.ImageCollection.extend({});
})(jQuery);
